<template>
  <b-card>
    <b-tabs>
      <b-tab
        :title="question.question"
        v-for="question in questions"
        :key="question.id"
        lazy
      >
        <b-row>
          <b-col lg="12">
            <object
              style="width: 100%; height: 80vh"
              :data="getAnswer(question.id)"
              type="application/pdf"
            >
              <embed
                style="width: 100%; height: 80vh"
                :src="getAnswer(question.id)"
                type="application/pdf"
              />
            </object>
          </b-col>
        </b-row>
        <b-row v-if="answer[question.id]">
          <b-col lg="12" v-if="answer[question.id].grade == null">
            <validation-observer
              ref="registerForm"
              #default="{ invalid }"
              v-if="$role != 'student'"
            >
              <b-form>
                <b-row>
                  <b-col lg="6">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('apology.reason')"
                      vid="reason"
                      rules="required"
                    >
                      <b-form-group
                        :label="$t('activities.put_grade')"
                        label-for="smallInput"
                      >
                        <b-form-input
                          v-model="evaluation"
                          id="smallInput"
                          type="number"
                          size="sm"
                          :placeholder="$t('activities.put_grade')"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col lg="6">
                    <b-button
                      block
                      :disabled="invalid"
                      variant="primary"
                      @click="setGrade(question.id)"
                    >
                      <i class="fa fa-plus" /> {{ $t("site.save") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>

            <validation-observer
              ref="registerForm"
              #default="{ invalid }"
              v-else
            >
              <b-form>
                <b-row>
                  <b-col cols="12">
                    <validation-provider
                      #default="{ errors }"
                      name="master"
                      vid="search_file"
                      rules="required"
                    >
                      <b-form-group class="mb-2">
                        <b-form-file
                          v-model="newAnswer[question.id].file"
                          placeholder="اختيار ملف أو تسقطها هنا ..."
                          drop-placeholder="إسقاط الملف هنا ..."
                          accept="application/pdf"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      block
                      :disabled="invalid"
                      variant="primary"
                      @click="submit()"
                    >
                      {{ $t("site.add") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-col>
          <b-col lg="12" v-else>
            <b-alert variant="info" show>
              <div class="alert-body">
                <span
                  ><strong>{{ $t("activities.grade") }} :</strong>
                  {{ answer[question.id].grade }}</span
                >
              </div>
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col lg="12">
            <validation-observer ref="registerForm" #default="{ invalid }">
              <b-form>
                <b-row>
                  <b-col cols="12">
                    <validation-provider
                      #default="{ errors }"
                      name="master"
                      vid="search_file"
                      rules="required"
                    >
                      <b-form-group class="mb-2">
                        <b-form-file
                          v-model="newAnswer[question.id].file"
                          placeholder="اختيار ملف أو تسقطها هنا ..."
                          drop-placeholder="إسقاط الملف هنا ..."
                          accept="application/pdf"
                          :state="errors.length > 0 ? false : null"
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      block
                      :disabled="invalid"
                      variant="primary"
                      @click="submit()"
                    >
                      {{ $t("site.add") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" v-if="!load">
            <comment-vue
              :commentable_id="question.id"
              commentable_type="App\ActivityUserAnswer"
              type="text"
            ></comment-vue>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <b-spinner v-if="load" type="grow" label="Loading..." class="loading" />
  </b-card>
</template>

<script>
import ActivitiesController from "@/Controllers/ActivitiesController";
import ActivityUserAnswerController from "@/Controllers/ActivityUserAnswerController";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import Auth from "@/Apis/Auth";
import CommentVue from "./Comment.vue";
const activityUserAnswerController = new ActivityUserAnswerController();
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    CommentVue,
  },
  data() {
    return {
      questions: [],
      newAnswer: [],
      userAnswer: [],
      userId: 0,
      load: false,
      evaluation: 0,
      answer: [],
    };
  },
  async created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.load = true;
      this.userId = Auth.USER.id;
      if (this.$route.params.userId) this.userId = this.$route.params.userId;
      this.userAnswer = await activityUserAnswerController.GetAll({
        filter: "user_id|" + this.userId,
      });
      const res = await new ActivitiesController().GetAll({
        type: "master",
        with: ["questions"],
      });
      this.questions = res[0].questions;
      this.questions.forEach((element) => {
        this.newAnswer[element.id] = {};
      });
      this.load = false;
    },
    async submit() {
      let data = {};
      this.newAnswer.forEach((element, index) => {
        console.log(element);
        if (element.file)
          data = {
            activity_question_id: index,
            user_id: Auth.USER.id,
            file: element.file,
            answer_number: 1,
          };
      });
     await activityUserAnswerController.From(data, "FormData");
       this.getData();
    },
    getAnswer(questionId) {
      const answer = this.userAnswer.find(
        (a) => a.activity_question_id == questionId
      );
      this.answer[questionId] = answer;
      if (answer) return answer.file;
      return "";
    },
    async setGrade(questionId) {
      console.log(questionId, this.answer[questionId].id);
      await activityUserAnswerController.From(
        {
          id: this.answer[questionId].id,
          grade: this.evaluation,
        },
        "FormData"
      );
       this.getData();
    },
  },
};
</script>

<style>
</style>